import React, { Component } from "react";
import { connect } from "react-redux";

import TopMediaComponent from "./TopMediaComponent";

class TopMedia extends Component {
  render() {
    return <TopMediaComponent {...this.props} />;
  }
}

const mapStateToProps = state => ({
  medias: state.medias.topMedias,
  lng: state.params.lng
});

export default connect(mapStateToProps)(TopMedia);



// WEBPACK FOOTER //
// ./src/components/Community/TopMedia/index.js